import React from "react";
import { cellGrow } from "constants/styles";
import ExternalLink from "components/ExternalLink";
import Link from "next/link";
import { useRouter } from "next/router";

const PaymentLinkCard = ({
  uuid,
  title,
  formattedValue,
  shortId,
  previewUrl,
  createdAt
}) => {
  const { asPath } = useRouter();
  const showPath = `${asPath}/links/${uuid}`;

  return (
    <div
      className={
        "hairline-1 ba br2 bg-white w-100 relative cell-grow bg-white--hover"
      }
    >
      <div className="flex flex-column bb hairline-1 justify-between">
        <Link href={showPath}>
          <div className="ph2 pv3 flex flex-row justify-between pointer">
            <div className="flex flex-row justify-between w-100 overflow-hidden pointer">
              <div className="f4 fw5 lh-title word-break pr1">{title}</div>
              {formattedValue && (
                <div className="f4 fw5 lh-title flex-shrink-0">
                  {formattedValue}
                </div>
              )}
            </div>
          </div>
        </Link>
        <div style={{ height: 33 }} className="w-100"></div>
        <div className="absolute bottom-0 right-0 left-0 z-1 center flex flex-row justify-between items-center w-100 bt hairline-1 pa2 bg-white f6">
          {createdAt && (
            <div className="f7 flex-shrink-0">Created: {createdAt}</div>
          )}
          <ExternalLink copy={shortId} href={previewUrl} />
        </div>
      </div>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

export default PaymentLinkCard;
